/**
 * <ParentTabBackground> — le fond d'un onglet de l'espace parent, pour la coquille legacy.
 *
 * `ParentTabScreenWrapper` (JS) enveloppe le header et l'écran de chaque onglet ; c'est le design
 * system qui peint l'écran (`<ScreenBackground>`) : la couleur de page du thème, clair ou nuit, et
 * la lueur quand l'enregistrement de l'onglet la demande (`parentTabScreens`, l'accueil seul). Le
 * header du DS ne pose aucune surface — c'est ce fond qu'on voit derrière lui.
 */
import React from "react"

import { ScreenBackground } from "../../../../../design-system"

export type ParentTabBackgroundProps = {
    children: React.ReactNode
    /** L'onglet porte la lueur d'accueil. */
    glow?: boolean
}

export function ParentTabBackground(props: ParentTabBackgroundProps) {
    const { children, glow = false } = props

    return <ScreenBackground glow={glow}>{children}</ScreenBackground>
}
